const state = {
	attendees: [],
	columns: {
		firstName: null,
		lastName: null,
		pronouns: null,
		role: null
	},
	fileName: '',
	formatId: '1x2.625-30',
	sheetOffsetX: 0,
	sheetOffsetY: 0,
	labelWidthAdjust: 0,
	labelHeightAdjust: 0,
	stickerOffset: 0,
	columnGapMm: 6.35,
	rowGapMm: 0,
	nameFontSize: 18,
	pronounsFontSize: 14,
	roleFontSize: 12,
	showBorders: true,
	savedPresets: []
};

const labelSortCollator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

const LABEL_FORMATS = {
	'1x2.625-30': {
		label: '1"x2-5/8"(30 up)',
		perSheet: 30,
		columns: 3,
		pageWidth: '8.5in',
		pageHeight: '11in',
		sheetPadding: '0.5in 0',
		labelWidth: '2.625in',
		labelHeight: '1in',
		columnGap: '0.25in',
		rowGap: '0',
		labelPadding: '0.08in 0.12in',
		labelContentGap: '0.04in',
		labelOffsetX: '0',
		labelOffsetY: '0',
		nameFontSize: '18px',
		pronounsFontSize: '14px',
		roleFontSize: '12px'
	},
	'2x4-10': {
		label: '2"x4"(10 up)',
		perSheet: 10,
		columns: 2,
		pageWidth: '8.5in',
		pageHeight: '11in',
		sheetPadding: '0.5in 0.25in',
		labelWidth: '4in',
		labelHeight: '2in',
		columnGap: '0',
		rowGap: '0',
		labelPadding: '0.18in 0.22in',
		labelContentGap: '0.08in',
		labelOffsetX: '0',
		labelOffsetY: '0',
		nameFontSize: '28px',
		pronounsFontSize: '20px',
		roleFontSize: '18px'
	},
	'8.5x5.5-2': {
		label: '8.5"x5.5"(2 up)',
		perSheet: 2,
		columns: 1,
		pageWidth: '8.5in',
		pageHeight: '11in',
		sheetPadding: '0',
		labelWidth: '8.5in',
		labelHeight: '5.5in',
		columnGap: 0,
		rowGap: 0,
		labelPadding: '0.42in 0.5in',
		labelContentGap: '0.14in',
		labelOffsetX: '0',
		labelOffsetY: '0',
		nameFontSize: '48px',
		pronounsFontSize: '30px',
		roleFontSize: '24px'
	},
	'8.5x11-1': {
		label: '8.5"x11"(1 up)',
		perSheet: 1,
		columns: 1,
		pageWidth: '8.5in',
		pageHeight: '11in',
		sheetPadding: '0',
		labelWidth: '8.5in',
		labelHeight: '11in',
		columnGap: 0,
		rowGap: 0,
		labelPadding: '0.75in 0.67in',
		labelContentGap: '0.18in',
		labelOffsetX: '0',
		labelOffsetY: '0',
		nameFontSize: '64px',
		pronounsFontSize: '40px',
		roleFontSize: '30px'
	}
};

const elements = {
	fileInput: document.getElementById('csv-file-input'),
	dropzone: document.getElementById('csv-dropzone'),
	formatSelect: document.getElementById('label-format-select'),
	sheetOffsetXInput: document.getElementById('sheet-offset-x'),
	sheetOffsetYInput: document.getElementById('sheet-offset-y'),
	labelWidthAdjustInput: document.getElementById('label-width-adjust'),
	labelHeightAdjustInput: document.getElementById('label-height-adjust'),
	stickerOffsetInput: document.getElementById('sticker-offset'),
	columnGapInput: document.getElementById('column-gap'),
	rowGapInput: document.getElementById('row-gap'),
	nameFontSizeInput: document.getElementById('name-font-size'),
	pronounsFontSizeInput: document.getElementById('pronouns-font-size'),
	roleFontSizeInput: document.getElementById('role-font-size'),
	showBordersInput: document.getElementById('show-borders'),
	savedSettingsSelect: document.getElementById('saved-settings-select'),
	applySettingsButton: document.getElementById('apply-settings-button'),
	saveSettingsButton: document.getElementById('save-settings-button'),
	saveSettingsDialog: document.getElementById('save-settings-dialog'),
	saveSettingsForm: document.getElementById('save-settings-form'),
	saveSettingsNameInput: document.getElementById('save-settings-name'),
	cancelSaveSettingsButton: document.getElementById('cancel-save-settings-button'),
	printButton: document.getElementById('print-button'),
	fileNamePill: document.getElementById('file-name-pill'),
	metricTotal: document.getElementById('metric-total'),
	metricWithRole: document.getElementById('metric-with-role'),
	metricWithoutRole: document.getElementById('metric-without-role'),
	detectedColumns: document.getElementById('detected-columns'),
	previewTableBody: document.getElementById('preview-table-body'),
	printGrid: document.getElementById('print-grid')
};

const HEADER_ALIASES = {
	firstName: [ 'firstname', 'first_name', 'first name', 'prenom', 'prénom', 'givenname', 'given name' ],
	lastName: [ 'lastname', 'last_name', 'last name', 'surname', 'familyname', 'family name', 'nom' ],
	pronouns: [ 'pronoms', 'pronom', 'pronouns', 'pronoun', 'preferred pronouns' ],
	role: [ 'role', 'job', 'title', 'position', 'poste', 'emploi', 'occupation' ]
};

const SETTINGS_COOKIE_NAME = 'evenix_csv_printer_settings';
const SETTINGS_PRESETS_COOKIE_NAME = 'evenix_csv_printer_presets';
const SETTINGS_COOKIE_MAX_AGE = 60 * 60 * 24 * 180;

function readCookie(name) {
	const cookiePrefix = `${name}=`;
	const cookie = document.cookie
		.split(';')
		.map((value) => value.trim())
		.find((value) => value.startsWith(cookiePrefix));

	return cookie ? cookie.slice(cookiePrefix.length) : null;
}

function writeCookie(name, value, maxAgeSeconds) {
	document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}; samesite=lax`;
}

function getSettingsPayload() {
	return {
		formatId: state.formatId,
		sheetOffsetX: state.sheetOffsetX,
		sheetOffsetY: state.sheetOffsetY,
		labelWidthAdjust: state.labelWidthAdjust,
		labelHeightAdjust: state.labelHeightAdjust,
		columnGapMm: state.columnGapMm,
		rowGapMm: state.rowGapMm,
		nameFontSize: state.nameFontSize,
		pronounsFontSize: state.pronounsFontSize,
		roleFontSize: state.roleFontSize,
		showBorders: state.showBorders
	};
}

function syncSettingsInputs() {
	elements.formatSelect.value = state.formatId;
	elements.sheetOffsetXInput.value = `${state.sheetOffsetX}`;
	elements.sheetOffsetYInput.value = `${state.sheetOffsetY}`;
	elements.labelWidthAdjustInput.value = `${state.labelWidthAdjust}`;
	elements.labelHeightAdjustInput.value = `${state.labelHeightAdjust}`;
	elements.stickerOffsetInput.value = `${state.stickerOffset}`;
	elements.columnGapInput.value = `${state.columnGapMm}`;
	elements.rowGapInput.value = `${state.rowGapMm}`;
	elements.nameFontSizeInput.value = `${state.nameFontSize}`;
	elements.pronounsFontSizeInput.value = `${state.pronounsFontSize}`;
	elements.roleFontSizeInput.value = `${state.roleFontSize}`;
	elements.showBordersInput.checked = state.showBorders;
}

function setSettingsFromPayload(payload) {
	const resolvedFormatId = typeof payload.formatId === 'string' && LABEL_FORMATS[payload.formatId]
		? payload.formatId
		: state.formatId;
	const resolvedFormat = LABEL_FORMATS[resolvedFormatId];

	state.formatId = resolvedFormatId;
	state.sheetOffsetX = getSheetOffsetValue(payload.sheetOffsetX);
	state.sheetOffsetY = getSheetOffsetValue(payload.sheetOffsetY);
	state.labelWidthAdjust = getSheetOffsetValue(payload.labelWidthAdjust);
	state.labelHeightAdjust = getSheetOffsetValue(payload.labelHeightAdjust);
	state.columnGapMm = getSheetOffsetValue(
		payload.columnGapMm !== undefined ? payload.columnGapMm : getMillimeterValue(resolvedFormat.columnGap)
	);
	state.rowGapMm = getSheetOffsetValue(
		payload.rowGapMm !== undefined ? payload.rowGapMm : getMillimeterValue(resolvedFormat.rowGap)
	);
	state.nameFontSize = getSheetOffsetValue(
		payload.nameFontSize !== undefined ? payload.nameFontSize : getPixelValue(resolvedFormat.nameFontSize)
	);
	state.pronounsFontSize = getSheetOffsetValue(
		payload.pronounsFontSize !== undefined ? payload.pronounsFontSize : getPixelValue(resolvedFormat.pronounsFontSize)
	);
	state.roleFontSize = getSheetOffsetValue(
		payload.roleFontSize !== undefined ? payload.roleFontSize : getPixelValue(resolvedFormat.roleFontSize)
	);
	state.showBorders = payload.showBorders !== undefined ? Boolean(payload.showBorders) : true;
}

function renderSavedPresetOptions() {
	const defaultOption = '<option value="">Select a saved setup</option>';
	const presetOptions = state.savedPresets
		.slice()
		.sort((left, right) => labelSortCollator.compare(left.name, right.name))
		.map((preset) => `<option value="${escapeHtml(preset.name)}">${escapeHtml(preset.name)}</option>`)
		.join('');

	elements.savedSettingsSelect.innerHTML = `${defaultOption}${presetOptions}`;
	elements.applySettingsButton.disabled = !state.savedPresets.length;
}

function persistSettings() {
	writeCookie(
		SETTINGS_COOKIE_NAME,
		encodeURIComponent(JSON.stringify(getSettingsPayload())),
		SETTINGS_COOKIE_MAX_AGE
	);
}

function persistSavedPresets() {
	writeCookie(
		SETTINGS_PRESETS_COOKIE_NAME,
		encodeURIComponent(JSON.stringify(state.savedPresets)),
		SETTINGS_COOKIE_MAX_AGE
	);
}

function restoreSavedPresets() {
	const rawCookie = readCookie(SETTINGS_PRESETS_COOKIE_NAME);

	if (!rawCookie) {
		renderSavedPresetOptions();
		return;
	}

	try {
		const savedPresets = JSON.parse(decodeURIComponent(rawCookie));
		state.savedPresets = Array.isArray(savedPresets)
			? savedPresets.filter((preset) => preset && typeof preset.name === 'string' && preset.settings)
			: [];
	} catch (error) {
		state.savedPresets = [];
		writeCookie(SETTINGS_PRESETS_COOKIE_NAME, '', 0);
	}

	renderSavedPresetOptions();
}

function restoreSettings() {
	const rawCookie = readCookie(SETTINGS_COOKIE_NAME);
	const defaultFormat = getSelectedFormat();

	if (!rawCookie) {
		state.columnGapMm = getMillimeterValue(defaultFormat.columnGap);
		state.rowGapMm = getMillimeterValue(defaultFormat.rowGap);
		state.nameFontSize = getPixelValue(defaultFormat.nameFontSize);
		state.pronounsFontSize = getPixelValue(defaultFormat.pronounsFontSize);
		state.roleFontSize = getPixelValue(defaultFormat.roleFontSize);
		syncSettingsInputs();
		return;
	}

	try {
		const savedSettings = JSON.parse(decodeURIComponent(rawCookie));
		setSettingsFromPayload(savedSettings);
	} catch (error) {
		writeCookie(SETTINGS_COOKIE_NAME, '', 0);
	}

	syncSettingsInputs();
}

function normalizeHeader(value) {
	return value
		.trim()
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-z0-9]+/g, ' ')
		.trim();
}

function titleCase(value) {
	return value
		.toLowerCase()
		.split(/\s+/)
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join(' ');
}

function escapeHtml(value) {
	return value
		.replaceAll('&', '&amp;')
		.replaceAll('<', '&lt;')
		.replaceAll('>', '&gt;')
		.replaceAll('"', '&quot;')
		.replaceAll("'", '&#39;');
}

function sortAttendees(attendees) {
	return [ ...attendees ].sort((left, right) => {
		const leftPrimaryName = left.lastName || left.firstName;
		const rightPrimaryName = right.lastName || right.firstName;
		const primaryNameComparison = labelSortCollator.compare(leftPrimaryName, rightPrimaryName);
		if (primaryNameComparison !== 0) {
			return primaryNameComparison;
		}

		const leftSecondaryName = left.lastName ? left.firstName : left.lastName;
		const rightSecondaryName = right.lastName ? right.firstName : right.lastName;
		const secondaryNameComparison = labelSortCollator.compare(leftSecondaryName, rightSecondaryName);
		if (secondaryNameComparison !== 0) {
			return secondaryNameComparison;
		}

		return labelSortCollator.compare(left.role, right.role);
	});
}

function getDisplayName(attendee) {
	return [ attendee.firstName, attendee.lastName ].filter(Boolean).join(' ');
}

function getDisplayPronouns(attendee) {
	if (!attendee.pronouns) {
		return '';
	}

	return `(${attendee.pronouns})`;
}

function chunkAttendees(attendees, chunkSize) {
	const chunks = [];

	for (let index = 0; index < attendees.length; index += chunkSize) {
		chunks.push(attendees.slice(index, index + chunkSize));
	}

	return chunks;
}

function getSelectedFormat() {
	return LABEL_FORMATS[state.formatId] || LABEL_FORMATS['1x2.625-30'];
}

function getSheetOffsetValue(value) {
	const parsed = Number.parseFloat(value);

	return Number.isFinite(parsed) ? parsed : 0;
}

function getStickerOffsetValue(value) {
	const parsed = Number.parseInt(value, 10);

	return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
}

function getAdjustedDimension(baseDimension, adjustment) {
	if (!adjustment) {
		return baseDimension;
	}

	return `calc(${baseDimension} + ${adjustment}mm)`;
}

function getPixelValue(value) {
	if (typeof value === 'number') {
		return value;
	}

	const parsed = Number.parseFloat(value);

	return Number.isFinite(parsed) ? parsed : 0;
}

function getMillimeterValue(value) {
	if (typeof value === 'number') {
		return value;
	}

	const stringValue = `${value}`.trim();
	const parsed = Number.parseFloat(stringValue);

	if (!Number.isFinite(parsed)) {
		return 0;
	}

	if (stringValue.endsWith('in')) {
		return Number((parsed * 25.4).toFixed(2));
	}

	if (stringValue.endsWith('px')) {
		return Number(((parsed * 25.4) / 96).toFixed(2));
	}

	return parsed;
}

function detectDelimiter(text) {
	const sample = text.split(/\r?\n/).slice(0, 5).join('\n');
	const delimiters = [ ',', ';', '\t' ];

	let bestDelimiter = ',';
	let bestScore = -1;

	delimiters.forEach((delimiter) => {
		const score = sample.split(delimiter).length;
		if (score > bestScore) {
			bestScore = score;
			bestDelimiter = delimiter;
		}
	});

	return bestDelimiter;
}

function parseCsv(text) {
	const delimiter = detectDelimiter(text);
	const rows = [];
	let currentCell = '';
	let currentRow = [];
	let insideQuotes = false;

	for (let index = 0; index < text.length; index += 1) {
		const character = text[index];
		const nextCharacter = text[index + 1];

		if (character === '"') {
			if (insideQuotes && nextCharacter === '"') {
				currentCell += '"';
				index += 1;
			} else {
				insideQuotes = !insideQuotes;
			}
			continue;
		}

		if (character === delimiter && !insideQuotes) {
			currentRow.push(currentCell);
			currentCell = '';
			continue;
		}

		if ((character === '\n' || character === '\r') && !insideQuotes) {
			if (character === '\r' && nextCharacter === '\n') {
				index += 1;
			}

			currentRow.push(currentCell);
			if (currentRow.some((cell) => cell.trim() !== '')) {
				rows.push(currentRow);
			}
			currentCell = '';
			currentRow = [];
			continue;
		}

		currentCell += character;
	}

	if (currentCell.length > 0 || currentRow.length > 0) {
		currentRow.push(currentCell);
		if (currentRow.some((cell) => cell.trim() !== '')) {
			rows.push(currentRow);
		}
	}

	return rows.map((row) => row.map((cell) => cell.trim()));
}

function detectHeaderRow(firstRow) {
	const normalized = firstRow.map(normalizeHeader);

	return normalized.some((header) =>
		Object.values(HEADER_ALIASES).some((aliases) => aliases.includes(header))
	);
}

function matchColumn(headers, key) {
	const aliases = HEADER_ALIASES[key];
	const normalizedHeaders = headers.map(normalizeHeader);
	const matchIndex = normalizedHeaders.findIndex((header) => aliases.includes(header));

	return matchIndex === -1 ? null : matchIndex;
}

function buildAttendees(rows) {
	if (!rows.length) {
		throw new Error('The CSV file is empty.');
	}

	const hasHeader = detectHeaderRow(rows[0]);
	const maxColumnCount = rows.reduce((largest, row) => Math.max(largest, row.length), 0);
	const headers = hasHeader
		? rows[0]
		: (maxColumnCount >= 4 ? [ 'first name', 'last name', 'pronoms', 'role' ] : [ 'first name', 'last name', 'role' ]);
	const dataRows = hasHeader ? rows.slice(1) : rows;

	const firstNameIndex = matchColumn(headers, 'firstName');
	const lastNameIndex = matchColumn(headers, 'lastName');
	const pronounsIndex = matchColumn(headers, 'pronouns');
	const roleIndex = matchColumn(headers, 'role');

	const resolvedFirstNameIndex = firstNameIndex === null ? 0 : firstNameIndex;
	const resolvedLastNameIndex = lastNameIndex === null ? 1 : lastNameIndex;
	const resolvedPronounsIndex = pronounsIndex;
	const resolvedRoleIndex = roleIndex;

	if (resolvedFirstNameIndex === null || resolvedLastNameIndex === null) {
		throw new Error('The CSV must contain first name and last name columns.');
	}

	const attendees = dataRows
		.map((row, rowIndex) => {
			const firstName = row[resolvedFirstNameIndex] || '';
			const lastName = row[resolvedLastNameIndex] || '';
			const pronouns = resolvedPronounsIndex === null ? '' : row[resolvedPronounsIndex] || '';
			const role = resolvedRoleIndex === null ? '' : row[resolvedRoleIndex] || '';

			if (!firstName.trim() && !lastName.trim()) {
				return null;
			}

			return {
				id: `${rowIndex + 1}`,
				firstName: titleCase(firstName.trim()),
				lastName: titleCase(lastName.trim()),
				pronouns: pronouns.trim(),
				role: role.trim()
			};
		})
		.filter(Boolean);

	const sortedAttendees = sortAttendees(attendees);

	if (!sortedAttendees.length) {
		throw new Error('No valid attendee rows were found in the CSV.');
	}

	return {
		attendees: sortedAttendees,
		columns: {
			firstName: headers[resolvedFirstNameIndex] || 'first name',
			lastName: headers[resolvedLastNameIndex] || 'last name',
			pronouns: resolvedPronounsIndex === null ? null : headers[resolvedPronounsIndex],
			role: resolvedRoleIndex === null ? null : headers[resolvedRoleIndex]
		},
		hasHeader
	};
}

function renderDetectedColumns(columns, hasHeader) {
	const modeText = hasHeader ? 'Header row detected.' : 'No header row detected. Using column order.';
	const pronounsText = columns.pronouns ? `"${columns.pronouns}"` : 'not provided';
	const roleText = columns.role ? `"${columns.role}"` : 'not provided';

	elements.detectedColumns.innerHTML = `
    <strong>${escapeHtml(modeText)}</strong>
    First name: "${escapeHtml(columns.firstName)}"
    <span aria-hidden="true">•</span>
    Last name: "${escapeHtml(columns.lastName)}"
    <span aria-hidden="true">•</span>
    Pronoms: ${escapeHtml(pronounsText)}
    <span aria-hidden="true">•</span>
    Role: ${escapeHtml(roleText)}
  `;
}

function renderMetrics(attendees) {
	const withRole = attendees.filter((attendee) => attendee.role).length;
	const withoutRole = attendees.length - withRole;

	elements.metricTotal.textContent = `${attendees.length}`;
	elements.metricWithRole.textContent = `${withRole}`;
	elements.metricWithoutRole.textContent = `${withoutRole}`;
}

function renderPreview(attendees) {
	elements.previewTableBody.innerHTML = attendees.map((attendee, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${escapeHtml(getDisplayName(attendee))}</td>
      <td>${escapeHtml(attendee.role || '—')}</td>
    </tr>
  `).join('');
}

function renderPrintGrid(attendees) {
	const format = getSelectedFormat();
	const paddedAttendees = [ ...Array.from({ length: state.stickerOffset }, () => null), ...attendees ];
	const pages = chunkAttendees(paddedAttendees, format.perSheet);
	const labelWidth = getAdjustedDimension(format.labelWidth, state.labelWidthAdjust);
	const labelHeight = getAdjustedDimension(format.labelHeight, state.labelHeightAdjust);
	const columnGap = `${state.columnGapMm}mm`;
	const rowGap = `${state.rowGapMm}mm`;
	const nameFontSize = `${state.nameFontSize}px`;
	const pronounsFontSize = `${state.pronounsFontSize}px`;
	const roleFontSize = `${state.roleFontSize}px`;

	const gridMarkup = pages.map((page) => {
		const labels = Array.from({ length: format.perSheet }, (_, index) => {
			const attendee = page[index];

			if (!attendee) {
				return '<article class="csv-label csv-label-empty" aria-hidden="true"></article>';
			}

			return `
				<article class="csv-label">
					<div class="csv-label-content">
						<div class="csv-label-name">${escapeHtml(getDisplayName(attendee))}</div>
						${attendee.pronouns ? `<div class="csv-label-pronouns">${escapeHtml(getDisplayPronouns(attendee))}</div>` : ''}
						${attendee.role ? `<div class="csv-label-role">${escapeHtml(attendee.role)}</div>` : ''}
					</div>
				</article>
			`;
		}).join('');

		return `
			<section class="csv-label-page">
				<div
					class="csv-label-sheet"
					style="
						--csv-page-width: ${format.pageWidth};
						--csv-page-height: ${format.pageHeight};
						--csv-sheet-padding: ${format.sheetPadding};
						--csv-sheet-offset-x: ${state.sheetOffsetX}mm;
						--csv-sheet-offset-y: ${state.sheetOffsetY}mm;
						--csv-label-columns: ${format.columns};
						--csv-label-width: ${labelWidth};
						--csv-label-height: ${labelHeight};
						--csv-label-column-gap: ${columnGap};
						--csv-label-row-gap: ${rowGap};
						--csv-label-padding: ${format.labelPadding};
						--csv-label-content-gap: ${format.labelContentGap};
						--csv-label-offset-x: ${format.labelOffsetX};
						--csv-label-offset-y: ${format.labelOffsetY};
						--csv-label-name-size: ${nameFontSize};
						--csv-label-pronouns-size: ${pronounsFontSize};
						--csv-label-role-size: ${roleFontSize};
						--csv-label-border-color: ${state.showBorders ? '#cdd4e3' : 'transparent'};
						--csv-label-print-border-color: ${state.showBorders ? '#b8b8b8' : 'transparent'};
					"
				>${labels}</div>
			</section>
			`;
	}).join('');

	elements.printGrid.innerHTML = gridMarkup;
}

function applyCurrentSettingsToUi() {
	syncSettingsInputs();
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
	}
}

function setStatus(message, type = 'idle') {
	if (!elements.status) {
		return;
	}

	elements.status.textContent = message;
	elements.status.dataset.state = type;
}

function setButtonsEnabled(isEnabled) {
	elements.printButton.disabled = !isEnabled;
}

function resetOutput() {
	state.attendees = [];
	state.columns = {
		firstName: null,
		lastName: null,
		pronouns: null,
		role: null
	};
	state.fileName = '';
	state.formatId = elements.formatSelect.value;

	elements.fileInput.value = '';
	elements.fileNamePill.textContent = 'No file loaded';
	elements.metricTotal.textContent = '0';
	elements.metricWithRole.textContent = '0';
	elements.metricWithoutRole.textContent = '0';
	elements.detectedColumns.textContent = 'Waiting for a file to detect columns.';
	elements.previewTableBody.innerHTML = `
    <tr class="csv-empty-row">
      <td colspan="3">No data loaded yet.</td>
    </tr>
  `;
	elements.printGrid.innerHTML = `
    <div class="csv-print-empty">
      Import a CSV file to generate printable sticker sheets.
    </div>
  `;
	setButtonsEnabled(false);
}

async function handleFile(file) {
	if (!file) {
		return;
	}

	try {
		const text = await file.text();
		const rows = parseCsv(text);
		const result = buildAttendees(rows);

		state.attendees = result.attendees;
		state.columns = result.columns;
		state.fileName = file.name;

		elements.fileNamePill.textContent = file.name;
		renderMetrics(result.attendees);
		renderDetectedColumns(result.columns, result.hasHeader);
		renderPreview(result.attendees);
		renderPrintGrid(result.attendees);
		setStatus(`${result.attendees.length} names imported and sorted alphabetically for ${getSelectedFormat().label}.`, 'success');
		setButtonsEnabled(true);
	} catch (error) {
		resetOutput();
		elements.fileNamePill.textContent = file.name;
		setStatus(error.message || 'The CSV file could not be processed.', 'error');
	}
}

function handleTemplateChange() {
	state.formatId = elements.formatSelect.value;
	state.columnGapMm = getMillimeterValue(getSelectedFormat().columnGap);
	state.rowGapMm = getMillimeterValue(getSelectedFormat().rowGap);
	state.nameFontSize = getPixelValue(getSelectedFormat().nameFontSize);
	state.pronounsFontSize = getPixelValue(getSelectedFormat().pronounsFontSize);
	state.roleFontSize = getPixelValue(getSelectedFormat().roleFontSize);
	syncSettingsInputs();
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(`${state.attendees.length} names ready for ${getSelectedFormat().label}.`, 'success');
	}
}

function handleStickerOffsetChange() {
	state.stickerOffset = getStickerOffsetValue(elements.stickerOffsetInput.value);
	syncSettingsInputs();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(
			`${state.attendees.length} names ready for ${getSelectedFormat().label} starting after ${state.stickerOffset} used sticker${state.stickerOffset === 1 ? '' : 's'}.`,
			'success'
		);
	}
}

function handleApplySavedSettings() {
	const selectedPresetName = elements.savedSettingsSelect.value;
	const selectedPreset = state.savedPresets.find((preset) => preset.name === selectedPresetName);

	if (!selectedPreset) {
		return;
	}

	setSettingsFromPayload(selectedPreset.settings);
	applyCurrentSettingsToUi();
	setStatus(`Applied saved setup "${selectedPreset.name}".`, 'success');
}

function handleSheetOffsetChange() {
	state.sheetOffsetX = getSheetOffsetValue(elements.sheetOffsetXInput.value);
	state.sheetOffsetY = getSheetOffsetValue(elements.sheetOffsetYInput.value);
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(
			`${state.attendees.length} names ready for ${getSelectedFormat().label} with ${state.sheetOffsetX}mm horizontal and ${state.sheetOffsetY}mm vertical calibration.`,
			'success'
		);
	}
}

function handleLabelSizeChange() {
	state.labelWidthAdjust = getSheetOffsetValue(elements.labelWidthAdjustInput.value);
	state.labelHeightAdjust = getSheetOffsetValue(elements.labelHeightAdjustInput.value);
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(
			`${state.attendees.length} names ready for ${getSelectedFormat().label} with ${state.labelWidthAdjust}mm width and ${state.labelHeightAdjust}mm height adjustment.`,
			'success'
		);
	}
}

function handleSpacingChange() {
	state.columnGapMm = getSheetOffsetValue(elements.columnGapInput.value);
	state.rowGapMm = getSheetOffsetValue(elements.rowGapInput.value);
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(
			`${state.attendees.length} names ready for ${getSelectedFormat().label} with ${state.columnGapMm}mm horizontal and ${state.rowGapMm}mm vertical spacing.`,
			'success'
		);
	}
}

function handleTextSizeChange() {
	state.nameFontSize = getSheetOffsetValue(elements.nameFontSizeInput.value);
	state.pronounsFontSize = getSheetOffsetValue(elements.pronounsFontSizeInput.value);
	state.roleFontSize = getSheetOffsetValue(elements.roleFontSizeInput.value);
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(
			`${state.attendees.length} names ready for ${getSelectedFormat().label} with ${state.nameFontSize}px name text, ${state.pronounsFontSize}px pronoms text, and ${state.roleFontSize}px role text size.`,
			'success'
		);
	}
}

function handleBorderToggleChange() {
	state.showBorders = elements.showBordersInput.checked;
	persistSettings();

	if (state.attendees.length) {
		renderPrintGrid(state.attendees);
		setStatus(
			`${state.attendees.length} names ready for ${getSelectedFormat().label} with sticker borders ${state.showBorders ? 'enabled' : 'disabled'}.`,
			'success'
		);
	}
}

function handleSavedPresetSelectionChange() {
	elements.applySettingsButton.disabled = !elements.savedSettingsSelect.value;
}

function openSaveSettingsDialog() {
	elements.saveSettingsNameInput.value = elements.savedSettingsSelect.value || '';

	if (typeof elements.saveSettingsDialog.showModal === 'function') {
		elements.saveSettingsDialog.showModal();
	}

	elements.saveSettingsNameInput.focus();
	/* istanbul ignore next */
	elements.saveSettingsNameInput.select();
}

function closeSaveSettingsDialog() {
	if (typeof elements.saveSettingsDialog.close === 'function') {
		elements.saveSettingsDialog.close();
	}
}

function handleSaveSettingsSubmit(event) {
	event.preventDefault();

	const presetName = elements.saveSettingsNameInput.value.trim();

	if (!presetName) {
		elements.saveSettingsNameInput.focus();
		return;
	}

	const presetIndex = state.savedPresets.findIndex((preset) => preset.name === presetName);
	const presetPayload = {
		name: presetName,
		settings: getSettingsPayload()
	};

	if (presetIndex === -1) {
		state.savedPresets.push(presetPayload);
	} else {
		state.savedPresets[presetIndex] = presetPayload;
	}

	persistSavedPresets();
	renderSavedPresetOptions();
	elements.savedSettingsSelect.value = presetName;
	elements.applySettingsButton.disabled = false;
	closeSaveSettingsDialog();
	setStatus(`Saved setup "${presetName}".`, 'success');
}

function bindDragAndDrop() {
	[ 'dragenter', 'dragover' ].forEach((eventName) => {
		elements.dropzone.addEventListener(eventName, (event) => {
			event.preventDefault();
			elements.dropzone.classList.add('is-dragging');
		});
	});

	[ 'dragleave', 'drop' ].forEach((eventName) => {
		elements.dropzone.addEventListener(eventName, (event) => {
			event.preventDefault();
			elements.dropzone.classList.remove('is-dragging');
		});
	});

	elements.dropzone.addEventListener('drop', (event) => {
		const [ file ] = event.dataTransfer.files;
		void handleFile(file);
	});
}

elements.fileInput.addEventListener('change', (event) => {
	const [ file ] = event.target.files;
	void handleFile(file);
});

elements.formatSelect.addEventListener('change', handleTemplateChange);
elements.sheetOffsetXInput.addEventListener('input', handleSheetOffsetChange);
elements.sheetOffsetYInput.addEventListener('input', handleSheetOffsetChange);
elements.labelWidthAdjustInput.addEventListener('input', handleLabelSizeChange);
elements.labelHeightAdjustInput.addEventListener('input', handleLabelSizeChange);
elements.stickerOffsetInput.addEventListener('input', handleStickerOffsetChange);
elements.columnGapInput.addEventListener('input', handleSpacingChange);
elements.rowGapInput.addEventListener('input', handleSpacingChange);
elements.nameFontSizeInput.addEventListener('input', handleTextSizeChange);
elements.pronounsFontSizeInput.addEventListener('input', handleTextSizeChange);
elements.roleFontSizeInput.addEventListener('input', handleTextSizeChange);
elements.showBordersInput.addEventListener('change', handleBorderToggleChange);
elements.savedSettingsSelect.addEventListener('change', handleSavedPresetSelectionChange);
elements.applySettingsButton.addEventListener('click', handleApplySavedSettings);
elements.saveSettingsButton.addEventListener('click', openSaveSettingsDialog);
elements.saveSettingsForm.addEventListener('submit', handleSaveSettingsSubmit);
elements.cancelSaveSettingsButton.addEventListener('click', closeSaveSettingsDialog);
elements.printButton.addEventListener('click', () => window.print());

bindDragAndDrop();
restoreSavedPresets();
restoreSettings();
resetOutput();
